// lbl.home
export const register = {
    title: "Hello World!",
    register: "Register",
    please_enter_id: "Please fill in all the fields",
    confirm: 'confirm',
    nationality: {
        name: 'nationality',
        placeholder: '',
        required: '',
        too_short: '',
        invalid: '',
    },
    id_card: {
        name: 'ID Card No.',
        placeholder: 'Please enter ID Card No. 13 digit',
        required: '',
        too_short: '',
        invalid: 'ID Card No. is incorrect.',
    },
    passport: {
        name: 'Passport No.',
        placeholder: 'Please enter Passport',
        required: '',
        too_short: '',
        invalid: '',
    },
    mobile: {
        name: 'Contact Number',
        placeholder: 'xxx-xxx-xxxx',
        required: 'Please enter contact Number',
        too_short: 'Please enter contact Number 10 digit',
        invalid: '',
    },
    login:{
        registerText: 'Register',
        loginText: 'Login'
    },
    menu:{
        main: 'Home',
        privilege: 'Rewards',
        mission: 'Mission'
    },
    form: {
        title: 'Register',
        requireText: 'Please fill in all the fields',
        nationalIdCard: {
            name: 'ID Card No.',
            placeholder: 'ID Card No.',
            required: 'Please enter ID Card No.',
            too_short: 'Please enter ID Card No. 13 digit',
            invalid: 'Please enter ID Card No Not Correct',
        },
        firstname: {
            name: 'First Name',
            placeholder: 'First Name',
            required: 'Please enter First Name',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Last Name',
            placeholder: 'Last Name',
            required: 'Please enter Last Name',
            too_short: '',
            invalid: '',
        },
        phone: {
            name: 'Contact Number',
            placeholder: 'Contact Number',
            required: 'Please enter Contact Number',
            too_short: '',
            invalid: '',
        },
        email: {
            name: 'E-mail',
            placeholder: 'E-mail',
            required: 'Please enter E-mail',
            too_short: '',
            invalid: 'E-mail incorrect',
        },
        gender: {
            name: 'Gender',
            placeholder: 'Gender',
            required: 'Please enter Gender',
            too_short: '',
            invalid: '',
        },
        passwordFormat: {
            name: 'Password Format',
            placeholder: 'Password Format',
            required: 'Please enter password Format',
            too_short: '',
            invalid: '',
        },
        password: {
            name: 'Password',
            placeholder: 'Password',
            required: 'Please enter password',
            too_short: 'Please enter password 8-20 digit',
            invalid: '',
        },
        passwordConfirm: {
            name: 'Confirm Password',
            placeholder: 'Confirm Password',
            required: 'Please confirm password',
            too_short: 'Please enter password 8-20 digit',
            invalid: '',
        },
        passwordNotRequire: {
            name: 'Password',
            placeholder: 'Password',
            required: '',
            too_short: 'Please enter password 8-20 digit',
            invalid: '',
            desc1: 'Password must contain 8-20 characters including',
            desc2: 'Captital letters, small letters, and numbers',
        },
        passwordConfirmNotRequire: {
            name: 'Confirm Password',
            placeholder: 'Confirm Password',
            required: '',
            too_short: 'Please enter password 8-20 digit',
            invalid: '',
            desc1: 'Password must contain 8-20 characters including',
            desc2: 'Captital letters, small letters, and numbers',
        },
        pin: {
            name: 'PIN Code',
            placeholder: 'PIN Code',
            required: 'Please enter PIN Code',
            too_short: 'Please enter PIN Code 8 digit',
            invalid: '',
            desc: 'Password must contain numbers 0-9 8 characters',
        },
        pinConfirm: {
            name: 'Confirm PIN Code',
            placeholder: 'Confirm PIN Code',
            required: 'Please confirm PIN Code',
            too_short: 'Please enter PIN Code 8 digit',
            invalid: '',
        },
        pinNoteRequire: {
            name: 'PIN Code',
            placeholder: 'PIN Code',
            required: '',
            too_short: 'Please enter PIN Code 8 digit',
            invalid: '',
            helpText: 'Password must contain numbers 0-9 8 characters',
        },
        pinConfirmNoteRequire: {
            name: 'Confirm PIN Code',
            placeholder: 'Confirm PIN Code',
            required: '',
            too_short: 'Please enter PIN Code 8 digit',
            invalid: '',
            helpText: 'Password must contain 8-20 characters including Captital letters, small letters, and numbers',
        },
        passwordFormatText: 'Password must contain 8-20 characters including Captital letters, small letters, and numbers',
        confirm: 'Confirm',
        acceptTerm: 'I Agree',
        acceptTermUrl: 'Consent Term and Condition and Privacy Policy',
        loading_register: 'Verifying your insurance data',

    },
    no_data: 'Data not found!',
    title_point_modal: "Thank you for the registration",
    title2_point_modal: "From welcome points for use your points to redeem rewards",
    title3_point_modal: "From welcome points and regular customer points  for use your points to redeem rewards",
    you_get: "You received",
    text_register_1: "You are not the Dhipaya insurance's customer </br> then cannot redeem the privildgse/rewards here.",
    text_register_2: 'You can redeem privildges/rewards at',
    goto_register_tip: 'Go to TIP Society Website',
    unregister: 'Data not found Please fill in your information',
    title_terms: 'Consent Form for Collection, Use, Disclosure of Personal Information',
    title_terms2: 'Promotional activities Policy on Disclosure of Personal Information to the Company',
};
